define.alias("shared/components/shared/upgrade/all-features-modal", "settings/components/shared/upgrade/all-features-modal");